import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getOrdersRequest: ['document'],
  getOrdersSuccess: ['data'],
  getOrdersError: ['error'],

  getOrderRequest: ['hash'],
  getOrderSuccess: ['order'],
  getOrderError: ['error'],

  sendTotemPaymentRequest: [],
  sendTotemPaymentSuccess: ['data'],
  sendTotemPaymentError: ['error'],

  getTotemConfirmationRequest: ['hash'],
  getTotemConfirmationSuccess: ['data'],
  getTotemConfirmationError: ['error'],
});

const INITIAL_STATE = Immutable({
  orders: [],
  order: {},
  confirmPaymentOrder: {},
  error: {},
  isLoading: false,
  isSubmit: false,
});

const getOrdersRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, isSubmit: false });
const getOrdersSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge({ ...data, isSubmit: true }).set('isLoading', false);
const getOrdersError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const getOrderRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true });
const getOrderSuccess = (state = INITIAL_STATE, { order }) => state.merge(order).set('isLoading', false);
const getOrderError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const sendTotemPaymentRequest = (state = INITIAL_STATE) => state.set('isLoading', true);
const sendTotemPaymentSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', true);
const sendTotemPaymentError = (state = INITIAL_STATE, { error }) => state.merge({ error }).set('isLoading', false);

const getTotemConfirmationRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });
const getTotemConfirmationSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', false);
const getTotemConfirmationError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

export default createReducer(INITIAL_STATE, {
  [Types.GET_ORDERS_REQUEST]: getOrdersRequest,
  [Types.GET_ORDERS_SUCCESS]: getOrdersSuccess,
  [Types.GET_ORDERS_ERROR]: getOrdersError,

  [Types.GET_ORDER_REQUEST]: getOrderRequest,
  [Types.GET_ORDER_SUCCESS]: getOrderSuccess,
  [Types.GET_ORDER_ERROR]: getOrderError,

  [Types.SEND_TOTEM_PAYMENT_REQUEST]: sendTotemPaymentRequest,
  [Types.SEND_TOTEM_PAYMENT_SUCCESS]: sendTotemPaymentSuccess,
  [Types.SEND_TOTEM_PAYMENT_ERROR]: sendTotemPaymentError,

  [Types.GET_TOTEM_CONFIRMATION_REQUEST]: getTotemConfirmationRequest,
  [Types.GET_TOTEM_CONFIRMATION_SUCCESS]: getTotemConfirmationSuccess,
  [Types.GET_TOTEM_CONFIRMATION_ERROR]: getTotemConfirmationError,
});
